export const SORT_BY_OPTIONS_MAPPING = {
  low_to_high_price: {
    id: "low_to_high_price",
    label: "Low To High Price",
    value: "base_price_amount",
  },
  high_to_low_price: {
    id: "high_to_low_price",
    label: "High To Low Price",
    value: "-base_price_amount",
  },
  low_to_high_discount: {
    id: "low_to_high_discount",
    label: "Low To High Discount",
    value: "discount_amount",
  },
  high_to_low_discount: {
    id: "high_to_low_discount",
    label: "High To Low Discount",
    value: "-discount_amount",
  },
};
const {
  low_to_high_price,
  high_to_low_price,
  low_to_high_discount,
  high_to_low_discount,
} = SORT_BY_OPTIONS_MAPPING;

export const SORT_BY_OPTIONS = [
  low_to_high_price,
  high_to_low_price,
  low_to_high_discount,
  high_to_low_discount,
];

export const DEFAULT_PRICE_RANGE = {
  min: 0,
  max: 10000,
};